import merge from "lodash.merge"

export default {
    parse(selected, spec, starMapWidth) {

        var lang = window.nse_config.language;
        var allow = [
            "la",
            "en",
            "ar",
            "zh",
            "cz",
            "ee",
            "fi",
            "fr",
            "de",
            "el",
            "he",
            "it",
            "ja",
            "ko",
            "hi",
            "fa",
            "ru",
            "es",
            "tr"
        ];
        if (allow.indexOf(lang) === -1) lang = 'en';

        var config = {
            form: false,
            controls: false,
            location: false,
            lang: lang,
            projection: "airy",
            disableAnimations: true,
            datapath: window.nse_config.assets_url + "d3/data/",
            width: starMapWidth,
            projectionRatio: null,
            background: {
                fill: 'transparent',
                stroke: 'transparent',
                width: 0
            },
            stars: {
                colors: false,
                designation: false,
                style: {
                    fill: "#ffffff",
                    opacity: 1
                },
                designationStyle: {
                    fill: "#ffffff",
                    font: "50px NotoSansJP, sans-serif",
                    align: "left",
                    baseline: "top"
                },
            },
            constellations: {
                names: false,
                lines: false,
                namesType: "iau",
                lineStyle: {
                    stroke: "#ffffff",
                    width: 0.8,
                    opacity: 1,
                },
                nameStyle: {
                    fill: "#ffffff",
                    align: "center",
                    baseline: "middle",
                    font: [
                        "14px NotoSansJP",
                        "12px NotoSansJP",
                        "11px NotoSansJPf"
                    ]
                },
            },
            zoomlevel: 1,
            planets: {
                show: false,
                names: false,
                which: [],
                namesType: lang,
                symbols: {},
                symbolStyle: {
                    fill: "#ffffff",
                    font: "14px NotoSansJP",
                    align: "center",
                    baseline: "middle"
                },
                nameStyle: {
                    fill: "#ffffff",
                    font: "14px NotoSansJP",
                    align: "center",
                    baseline: "middle"
                },

            },
            interactive: false,
            mw: {
                show: false,
                style: {fill: "#ffffff", opacity: 0.15}
            },
            dsos: {
                show: false
            },
            lines: {
                graticule: {
                    show: false,
                    stroke: "#ffffff",
                    width: 0.6,
                    opacity: 0.6,
                },
                ecliptic: {show: false},
                galactic: {show: false},
                equatorial: {show: false},
            }
        };

        if (selected.poster_addon) {
            config.lines.graticule.show = selected.poster_addon.value.indexOf('graticule') >= 0;
            config.mw.show = selected.poster_addon.value.indexOf("milky-way") >= 0;
            config.constellations.lines = selected.poster_addon.value.indexOf('constellations') >= 0;
            config.constellations.names = selected.poster_addon.value.indexOf('constellations-name') >= 0;
            config.planets.show = selected.poster_addon.value.indexOf('planet-position') >= 0;

            var planets = {
                which: ["ter"],
                symbols: {}
            };

            if (selected.poster_addon.value.indexOf("moon") >= 0) {
                planets.which = planets.which.concat(['lun']);
                planets.symbols = {};
            }

            if (config.planets.show) {
                planets.which = planets.which.concat(["sol", "mer", "ven", "mar", "jup", "sat", "ura", "nep"]);

            }

            if (planets.which.length > 0) {
                config.planets.show = true;
                config.planets.names = true;
                config.planets.which = planets.which;

                var planetsName = {
                    "sol": {symbol: "\u25cf", letter: "Su", fill: "#ffffff", size: 12},  // Sun
                    "mer": {symbol: "\u25cf", letter: "Me", fill: "#ffffff"},            // Mercury
                    "ven": {symbol: "\u25cf", letter: "V", fill: "#ffffff"},             // Venus
                    "ter": {symbol: "\u25cf", letter: "T", fill: "#ffffff"},             //
                    "lun": {symbol: "\u25cf", name: " ", letter: " ", fill: "#ffffff", size: 12},   // Moon
                    "mar": {symbol: "\u25cf", letter: "Ma", fill: "#ffffff"},            // Mars
                    "cer": {symbol: "\u25cf", letter: "C", fill: "#ffffff"},             //
                    "ves": {symbol: "\u25cf", letter: "Ma", fill: "#ffffff"},            //
                    "jup": {symbol: "\u25cf", letter: "J", fill: "#ffffff"},             // Jupiter
                    "sat": {symbol: "\u25cf", letter: "Sa", fill: "#ffffff"},            // Saturn
                    "ura": {symbol: "\u25cf", letter: "U", fill: "#ffffff"},             // Uranus
                    "nep": {symbol: "\u25cf", letter: "N", fill: "#ffffff"},             // Neptune
                    "plu": {symbol: "\u25cf", letter: "P", fill: "#ffffff"},             // Pluto
                    "eri": {symbol: "\u25cf", letter: "E", fill: "#ffffff"}              //
                };
                planets.which.map(w => {
                    config.planets.symbols[w] = planetsName[w];
                })
            }
        }

        if (spec) {
            config.lines.graticule.width = spec.star_map.line_graticule_width_modifier;
            config.stars.size = spec.star_map.star_size_modifier
            config.constellations.lineStyle.width = spec.star_map.constellation_line_style_width_modifier;

            config.constellations.nameStyle.font = [
                `${spec.star_map.constellation_name_font_size}px NotoSansJP, sans-serif`,
                `${spec.star_map.constellation_name_font_size}px NotoSansJP, sans-serif`,
                `${spec.star_map.constellation_name_font_size}px NotoSansJP, sans-serif`
            ];

            config.stars.designationStyle.font = `${spec.star_map.star_name_font_size}px NotoSansJP, sans-serif`;
            config.planets.symbolStyle.font = `${spec.star_map.planet_name_font_size}px NotoSansJP, sans-serif`;
            config.planets.nameStyle.font = `${spec.star_map.planet_name_font_size}px NotoSansJP, sans-serif`;
        }

        if (selected.final_product && selected.final_product.value === 'canvas'
            && selected.star_map_color.value === '#000000') {
            config.mw.style.opacity = 0.16
        } else if (selected.star_map_color.value === '#000000') {
            config.mw.style.opacity = 0.12
        } else {
            config.mw.style.opacity = 0.1
        }


        // console.log(JSON.stringify(spec, undefined, 4))
        // console.log(JSON.stringify(config, undefined, 4))
        // console.log(JSON.stringify(selected.poster_addon, undefined, 4))
        // console.log(JSON.stringify(config.planets, undefined, 4))
        return merge(config, window.nse_config.celestial_config);
    }
}
